import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import promise from 'redux-promise';
import multi from 'redux-multi';
import reducers from './rootReducer';

const devTools = window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__();
const store = applyMiddleware(thunk, promise, multi)(createStore)(reducers,devTools);
// const store = applyMiddleware(thunk, promise, multi)(createStore)(reducers);

export default store;